<template>
    <flex-element :element-type="elementType" class="f-overflow-hidden" class-default-inline="f-bg-white">
        <!-- drawer header: -->
        <o-container
            class="f-py-0.75 f-pr-0.5 f-flex f-items-center f-justify-between f-cursor-pointer"
            v-bind="element(1)"
            display-name="Drawer Header"
            @click.native="drawerOnClick"
            @element-updated="elementUpdated"
        >
            <template v-slot="{ element, elementUpdated }">
                <a-text-single-line class-default="f-text-1.25 f-text-gray-800" v-bind="element(1)" @element-updated="elementUpdated">
                    Collapsible Title
                </a-text-single-line>

                <o-container
                    class-default="f-text-1.75 f-text-blue-500"
                    v-bind="element(2)"
                    display-name="Icon"
                    @element-updated="elementUpdated"
                >
                    <a-icon
                        v-if="isIconVisible"
                        :icon="iconDefaultImg"
                        :is-selectable="false"
                        style="pointer-events: none"
                    />
                </o-container>
            </template>
        </o-container>

        <!-- drawer body: -->
        <div
            class="collapsible__body"
            :style="drawerBodyStyleObj"
        >
            <div ref="collapsibleBody">
                <drop-zone-single
                    class-default="f-w-1/1"
                    v-bind="element(2)"
                    display-name="Drawer Content"
                    top-level
                    @drop="removeHeight"
                    @element-updated="elementUpdated"
                />
            </div>
        </div>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

const ANIMATION_SPEED = 0.3; // in seconds

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Drawer',
        },

        iconCollapsed: {
            type: String,
            required: true,
        },

        iconExpanded: {
            type: String,
            required: true,
        },

        expandedDrawerIndex: {
            type: Number,
            required: true,
        },

        closeOtherDrawers: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            height: 0,
            iconImgCollapsed: '',
            iconImgExpanded: '',
            isDrawerBodyVisible: false,
        };
    },

    computed: {
        drawerBodyStyleObj() {
            let styleObj;

            if (this.isDrawerBodyVisible) {
                styleObj = {
                    transition: `${ ANIMATION_SPEED }s all ease`,
                    height: this.height,
                    opacity: 1,
                };
            } else {
                styleObj = {
                    transition: `${ ANIMATION_SPEED }s all ease`,
                    height: this.height,
                    pointerEvents: 'none',
                    padding: 0,
                    opacity: 0,
                    transform: 'translateY(-20px)',
                };
            }

            return styleObj;
        },

        iconDefaultImg() {
            return this.isDrawerBodyVisible ? this.iconExpanded : this.iconCollapsed;
        },

        isIconVisible() {
            // only show the icon if one has been chosen for the current collapsed/expanded state
            return (this.isDrawerBodyVisible && !!this.iconExpanded) || (!this.isDrawerBodyVisible && !!this.iconCollapsed);
        },
    },

    watch: {
        expandedDrawerIndex(drawerIndex) {
            if (drawerIndex !== this.index && this.closeOtherDrawers) {
                this.isDrawerBodyVisible = false;
                this.height = 0;
            }
        },
    },

    methods: {
        drawerOnClick() {
            this.isDrawerBodyVisible = !this.isDrawerBodyVisible;

            const contentHeight = this.$refs.collapsibleBody.offsetHeight;

            if (!this.isDrawerBodyVisible) {
                this.height = 0;
            } else {
                this.height = `${ contentHeight }px`;

                // we need to remove the height after the animation is done
                // otherwise the drop zone will never be visible
                window.setTimeout(this.removeHeight, ANIMATION_SPEED * 1000);
            }

            if (this.isDrawerBodyVisible) {
                this.$emit('expanded', this.index);
            }
        },

        removeHeight() {
            this.height = 'auto';
        },
    },
};
</script>
